module.exports = __webpack_public_path__ + "media/assets/icons/service-icon-0b2301e7866b7ce9b01e4d6e497ec3b3.svg";